module.exports = __webpack_public_path__ + "img/16.29b2f09f.jpg";